const typeNamespace = 'COMMON';

// Clear
export const CLEAR = `${typeNamespace}_CLEAR`;

export const FLUSH_QUEUE = `${typeNamespace}_FLUSH_QUEUE`;

// navigation
export const SET_NAVIGATION = `${typeNamespace}_SET_NAVIGATION`;

// Constants
export const CONSTANTS_REQUEST = `${typeNamespace}_CONSTANTS_REQUEST`;
export const CONSTANTS_FAILURE = `${typeNamespace}_CONSTANTS_FAILURE`;
export const CONSTANTS_SUCCESS = `${typeNamespace}_CONSTANTS_SUCCESS`;

// Errors
export const ADD_ERRORS = `${typeNamespace}_ADD_ERRORS`;
export const REMOVE_ERRORS = `${typeNamespace}_REMOVE_ERRORS`;

// Wait
export const ADD_WAIT = `${typeNamespace}_ADD_WAIT`;
export const REMOVE_WAIT = `${typeNamespace}_REMOVE_WAIT`;

// Queue
export const ADD_QUEUE = `${typeNamespace}_ADD_QUEUE`;
export const REMOVE_QUEUE = `${typeNamespace}_REMOVE_QUEUE`;

// Global
export const SET_GLOBAL = `${typeNamespace}_SET_GLOBAL`;

// Config
export const SET_CONFIG = `${typeNamespace}_SET_CONFIG`;

// SetTour
export const SET_TOUR = `${typeNamespace}_SET_TOUR`;

// Contact Us

export const CONTACT_US_REQUEST = `${typeNamespace}_CONTACT_US_REQUEST`;
